// Bounded retry for 3DLOOK ingest. Backend answers HTTP 202 {detail:"...still computing..."}
// (fetch treats 202 as ok) while SAIA is still processing; real errors (401/403/409/422) throw.
// 3DLOOK two-photo processing is published as < 45 s → retry for up to 60 s (hard cap on attempts too).
export const SCAN_RETRY = { attempts: 13, delayMs: 5000, budgetMs: 60000 };

export const isStillProcessing = (r) =>
  !!r && !r.profile_id && /still computing/i.test(String(r.detail || ''));

const wait = (ms) => new Promise((res) => setTimeout(res, ms));

export async function ingestWithRetry(call, {
  attempts = SCAN_RETRY.attempts, delayMs = SCAN_RETRY.delayMs, budgetMs = SCAN_RETRY.budgetMs,
  sleep = wait, now = Date.now,
} = {}) {
  const start = now();
  for (let i = 1; i <= attempts; i += 1) {
    const r = await call();
    if (!isStillProcessing(r)) return r;
    if (i === attempts || now() - start + delayMs > budgetMs) break;
    await sleep(delayMs);
  }
  const err = new Error('Your measurements are still being computed by 3DLOOK. Your scan is saved — please tap Try Again in a minute.');
  err.code = 'SCAN_STILL_PROCESSING';
  throw err;
}
